import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HookSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-white" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-92">
          

          <div className="prose prose-lg max-w-none text-[#2d2d2d] leading-relaxed space-y-6" data-id="element-93">
            <p className="text-xl" data-id="element-94">
              ¿Te ha pasado que te despiertas a las 3 de la mañana con un calor
              insoportable y ya no puedes volver a dormir? Sientes que tu
              abdomen se inflama con cualquier cosa que comes y, por más que
              intentas "cerrar la boca", la báscula no se mueve.
            </p>

            <p className="text-xl" data-id="element-95">
              Sé lo que sientes. No es falta de voluntad, es tu cuerpo
              intentando decirte que tus hormonas han cambiado las reglas del
              juego. Y la solución no está en comer menos, sino en entender tu
              nuevo metabolismo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}